<div class="risk-dialog">
  <div class="header">Select Risk Level</div>
  <button class="close-btn" type="button" (click)="onCancel()" aria-label="Close risk dialog">
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="riskForm" (ngSubmit)="onContinue()">
    <div class="input-container">
      <div class="form-field">
        <label>Risk Level</label>
        <app-dropdown
          formControlName="riskLevel"
          placeholder="Select a risk level"
          [options]="riskLevelOptions"
          [isInvalid]="!!(riskForm.get('riskLevel')?.invalid && riskForm.get('riskLevel')?.touched)"
          errorMessage="Risk level is required"
        />
      </div>
    </div>

    <div class="buttons">
      <app-button buttonVariant="dialog-secondary" buttonType="button" (buttonClick)="onCancel()">Cancel</app-button>
      <app-button buttonVariant="dialog-primary" buttonType="submit" [state]="continueButtonState">
        Set Risk
      </app-button>
    </div>
  </form>
</div>
